import styled from 'styled-components';
import AppWrapper from '../../layout/AppWrapper';
import SaleOverview from '../../components/user/dashboard/SaleOverview';
import InvetorySummary from '../../components/user/dashboard/InventorySummary';
import ProductSummary from '../../components/user/dashboard/ProductSummary';
import TopSellingStock from '../../components/user/dashboard/TopSellingStock';
import LowQuatityStock from '../../components/user/dashboard/LowQuatityStock';
import ServicesSummary from '../../components/user/dashboard/ServicesSummary';
import Title from '../../utils/Title';
import { useDashboardContext } from '../../context/dashboard_context';
import AppLoader from '../../utils/AppLoader';
import { useEffect } from 'react';
import CustomChart from '../../utils/CustomChart';


const Dashboard = () => {
  const { dashboardLoading, getDashboardData, dashboardGraphLoading, dashboardGraphData, getDashboardGraphData,
  } = useDashboardContext();


  useEffect(() => {
    getDashboardData();
    getDashboardGraphData();
  }, []);

  return (
    <AppWrapper
      pagename={"dashboard"}
    >
      <AppLoader
        load={dashboardLoading}
      />
      <StyledDashboard>
        <Title title={"Dashboard"} />

        <div className="row">
          <div className="mb-4 col-lg-7">
            <SaleOverview />
          </div>
          <div className="mb-4 col-lg-5">
            <InvetorySummary />
          </div>
        </div>
        <div className="row">
          <div className="mb-4 col-lg-7">
            <CustomChart
              title={'Sales and Expenses'}
              chartData={dashboardGraphData}
              loading={dashboardGraphLoading}
            />
          </div>
          <div className="mb-4 col-lg-5">
            <div className="mb-4">
              <ProductSummary />
            </div>
            <ServicesSummary />
          </div>
        </div>
        <div className="row">
          <div className="mb-4 col-lg-7">
            <TopSellingStock />
          </div>
          <div className="mb-4 col-lg-5">
            <LowQuatityStock />
          </div>
        </div>

      </StyledDashboard>

    </AppWrapper>
  );
};

export default Dashboard;

const StyledDashboard = styled.div`
  
`

